import { BaseAction, actionTypes } from 'redux/actions';

/**
 * @description 會員登出
 */
export const logOut = ():BaseAction => {
  return {
    type: actionTypes.MEMBER.LOG_OUT
  };
};
